module.exports = __webpack_public_path__ + "media/images/pic/anime/varia-b2b54f7c7035b6fd5fef8f1470f48aee.svg";